var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25255 4.18144C2.4879 5.10566 1.04572 5.87246 1.05079 5.88769C1.05333 5.90039 1.64747 6.22539 2.36857 6.60371L3.67872 7.29434L3.68634 6.90332L3.69396 6.50977L3.96564 6.37266C4.84669 5.93086 5.6922 5.67441 6.63673 5.55762C7.03536 5.50937 7.88849 5.50176 8.27443 5.54492C9.24435 5.64902 10.1 5.90547 11.0115 6.35996L11.3086 6.50977V6.90332C11.3086 7.11914 11.3111 7.29687 11.3162 7.29687C11.3188 7.29687 11.5727 7.16738 11.8799 7.00742L12.4385 6.71797L12.4461 8.15762L12.4512 9.5998L12.0576 10.4453L11.6641 11.2883L12.0373 11.6818C12.2455 11.8977 12.507 12.1744 12.6238 12.2937L12.832 12.5146L13.0428 12.2937C13.157 12.1744 13.4186 11.8977 13.6242 11.6818L14 11.2908L13.6065 10.4453L13.2129 9.5998V7.95703V6.31172L13.6039 6.09844L13.9975 5.88769L13.9289 5.84707C13.7309 5.72773 7.5254 2.49805 7.49494 2.50059C7.47716 2.50059 6.0172 3.25723 4.25255 4.18144Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11914 6.28379C6.31426 6.32188 5.48145 6.52246 4.69434 6.86523L4.45312 6.97188V8.51816V10.0645H7.5H10.5469V8.51816V6.97188L10.2828 6.85508C9.26973 6.41328 8.26172 6.23047 7.11914 6.28379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningCenter);
export default __webpack_public_path__ + "static/media/LearningCenter.d26c63102f0ab102475ea7dc0dcde40a.svg";
export { ForwardRef as ReactComponent };